<template>
    <div class="group">
        <span
            id="symbolIcon"
            v-bind:class="{'esri-icon-blank-map-pin': !isSymbolSelected, 'esri-icon-map-pin': isSymbolSelected}"
            v-bind:title="tooltip"
            v-on:click="$emit('symbolChange', [title])"
            v-if="title !== 'Federal Aid Committee'"
        ></span>
        <strong> {{title}}</strong>
        <Dropdown
                v-for="dropdown in dropdownsWithValues"
                v-bind:key="dropdown.name"
                v-bind:options="dropdown.values"
                v-bind:selected="dropdown.selected"
                v-bind:clear="clear"
                v-on:input="$emit('input', [dropdown.name, $event])"
        />
    </div>
</template>

<script>
    import Dropdown from "./Dropdown";
    export default {
        name: "Group",
        components: {Dropdown},
        props: ['title', 'dropdowns', 'clear', 'symbology'],
        computed: {
            dropdownsWithValues: function () {
                return this.dropdowns.filter(v => v.values.length)
            },
            isSymbolSelected: function () {
                return this.symbology === this.title;
            }
        },
        data: function () {
            return {
                tooltip: "Color the mapped projects based on " + this.title
            }
        }
    }
</script>

<style scoped>
    .group {
        padding: 4px 2px;
        color: #FFFFFF;
        background: #64983d;
        font-size: 1.25rem;
        margin-bottom: 1px;
        line-height: 1;
    }
    #symbolIcon {
        color: #64983d;
        background: #FFF;
        padding: 4px 2px;
        font-size: 1.25rem;
        margin-bottom: 1px;
        line-height: 1;
        border-radius: 4px;
        cursor: pointer !important;
        box-shadow: 2px 3px #656565;
    }
    .esri-icon-map-pin {
        background-color: cyan !important;
        color: #333 !important;
        font-weight: bold !important;
    }
    .esri-icon-map-pin:hover {
        background-color: #22eeee !important;
        color: #222 !important;
    }
    .esri-icon-map-pin:active, #symbolIcon:active {
        background-color: #44dddd !important;
    }
    #symbolIcon:hover {
        background-color: #d9d9d9;
        font-weight: bold;
    }
</style>
